
<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="employeeSalaryInformation">

      

      <div class="vx-row">
        <div class="vx-col lg:w-1/3 w-full">
          <vx-card class="mb-base">
              <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex items-end px-3 text-primary">
                        <feather-icon svgClasses="w-6 h-6" icon="UserIcon" class="mr-2" />
                        <span class="font-medium text-xl leading-none text-primary">Information</span>
                    </div>
                    <vs-divider />
                </div>
                </div>
                    <table>
                    <tr>
                        <td class="font-semibold">Payment Mode<span style="color:red">*</span> :</td>
                        <td v-if="isEdit"> <v-select v-validate="'required'" name="Payment Mode" v-model="paymentMode" label="paymentModeName" :options="getAllPaymentModeLookup" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('Payment Mode')">{{ errors.first('Payment Mode') }}</span>
                        </td>
                        <td v-else>{{ paymentModeName(employeeSalaryInformation.paymentModeId).paymentModeName }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">SSS No :</td>
                        <td v-if="isEdit"> <vs-input v-model="sssNumber" placeholder="SSS No" /></td>
                        <td v-else>{{ employeeSalaryInformation.sssNumber }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">PhilHealth No :</td>
                        <td v-if="isEdit"> <vs-input v-model="philhealthNumber" placeholder="PhilHealth No" /></td>
                        <td v-else>{{ employeeSalaryInformation.philhealthNumber }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">PagIbig No :</td>
                        <td v-if="isEdit"> <vs-input v-model="pagibigNumber" placeholder="PagIbig No" /></td>
                        <td v-else>{{ employeeSalaryInformation.pagibigNumber }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">TIN No :</td>
                        <td v-if="isEdit"> <vs-input v-model="tinNumber" placeholder="TIN No" /></td>
                        <td v-else>{{ employeeSalaryInformation.tinNumber }}</td>
                    </tr>
                   
                    
                    </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-2/3 w-full">
        
          <vx-card class="mb-base">
              <div class="vx-col w-full">
                    <div class="flex items-end px-3 text-primary">
                        <feather-icon svgClasses="w-6 h-6" icon="HomeIcon" class="mr-2" />
                        <span class="font-medium text-xl leading-none text-primary">Settings</span>
                    </div>
                    <vs-divider />
             </div>
             <div class="mt-5">
                       <div class="vx-row">
                            <div class="vx-col flex-1 " id="account-info-col-1">
                                <table>
                                    <tr>
                                        <td class="font-semibold">Allow SSS :</td>
                                        <td><vs-checkbox v-model="employeeSalaryInformation.isSSS" :disabled="!isEdit"/></td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Allow PhilHealth :</td>
                                        <td><vs-checkbox v-model="employeeSalaryInformation.isPhilhealth" :disabled="!isEdit"/></td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Allow Pagibig :</td>
                                        <td><vs-checkbox v-model="employeeSalaryInformation.isPagibig" :disabled="!isEdit"/></td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Allow Witholding Tax :</td>
                                        <td><vs-checkbox v-model="employeeSalaryInformation.isWHTax" :disabled="!isEdit"/></td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Tax Deduction Sched :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="tax deduction schedule" v-model="taxReference" label="taxReferenceName" :options="getAllTaxReferenceLookup" placeholder="Please Select" />
                                            <span class="text-danger text-sm" v-show="errors.has('tax deduction schedule')">{{ errors.first('tax deduction schedule') }}</span>
                                        </td>
                                        <td v-else>{{ taxReferenceName(employeeSalaryInformation.taxReferenceId).taxReferenceName }}</td>
                                    </tr>
                                   
                                    
                                    
                                    
                                </table>
                            </div>
                            <div class="vx-col flex-1 " id="account-info-col-2">
                                <table>
                                    <tr>
                                        <td class="font-semibold">SSS Deduction Sched :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="SSS Period" v-model="sssPeriod" label="periodName" :options="getAllPeriodLookup" placeholder="Please Select" :disabled="!employeeSalaryInformation.isSSS" />
                                            <span class="text-danger text-sm" v-show="errors.has('SSS Period')">{{ errors.first('SSS Period') }}</span>
                                        </td>
                                        <td v-else>{{ periodName(employeeSalaryInformation.sssPeriodId).periodName  }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">PHL Deduction Sched :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="PHL Period" v-model="phlPeriod" label="periodName" :options="getAllPeriodLookup" placeholder="Please Select" :disabled="!employeeSalaryInformation.isPhilhealth"/>
                                            <span class="text-danger text-sm" v-show="errors.has('PHL Period')">{{ errors.first('PHL Period') }}</span>
                                        </td>
                                        <td v-else>{{ periodName(employeeSalaryInformation.philhealthPeriodId).periodName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">HDMF Deduction Sched :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="HDMF Period" v-model="hdmfPeriod" label="periodName" :options="getAllPeriodLookup" placeholder="Please Select" :disabled="!employeeSalaryInformation.isPagibig" />
                                            <span class="text-danger text-sm" v-show="errors.has('HDMF Period')">{{ errors.first('HDMF Period') }}</span>
                                        </td>
                                        <td v-else>{{ periodName(employeeSalaryInformation.pagibigPeriodId).periodName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">WHTax Deduction Sched :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="WHtax Period" v-model="whtaxPeriod" label="periodName" :options="getAllPeriodLookup" placeholder="Please Select" :disabled="!employeeSalaryInformation.isWHTax" />
                                            <span class="text-danger text-sm" v-show="errors.has('WHtax Period')">{{ errors.first('WHtax Period') }}</span>
                                        </td>
                                        <td v-else>{{ periodName(employeeSalaryInformation.whTaxPeriodId).periodName }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Salary Based On :</td>
                                        <td v-if="isEdit"> <v-select v-validate="'required'" name="salary based on" v-model="salaryBasedOn" label="salaryBasedOnName" :options="getAllSalaryBasedOnLookup" placeholder="Please Select" />
                                            <span class="text-danger text-sm" v-show="errors.has('salary based on')">{{ errors.first('salary based on') }}</span>
                                        </td>
                                        <td v-else>{{ salaryBasedOnName(employeeSalaryInformation.salaryBasedOnId).salaryBasedOnName }}</td>
                                    </tr>
                                    
                                    
                                </table>
                            </div>
                        </div>

                  
             </div>

              
          </vx-card>
          
        
        </div>

        
      </div>



        <vx-card class="mb-base">
          <div class="vx-col w-full">
                    <div class="flex items-end px-3 text-primary">
                        <feather-icon svgClasses="w-6 h-6" icon="UserIcon" class="mr-2" />
                        <span class="font-medium text-xl leading-none text-primary">Fixed & Percentage Amounts</span>
                    </div>
                    <vs-divider />
             </div>
        <!-- Avatar -->
        <div class="vx-row">

         
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Fixed SSS Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="SSS amount" v-model="fixedSSSAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('SSS amount')">{{ errors.first('SSS amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedSSSAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fixed SSS ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="SSS ER amount" v-model="fixedSSSEmployerAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('SSS ER amount')">{{ errors.first('SSS ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedSSSEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fixed EC Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="EC amount" v-model="fixedECAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('EC amount')">{{ errors.first('EC amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedECAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fixed PHL Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="PHL amount" v-model="fixedPhilhealthAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('PHL amount')">{{ errors.first('PHL amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedPhilhealthAmount }}</td>
              </tr>
               <tr>
                <td class="font-semibold">Fixed PHL ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="PHL ER amount" v-model="fixedPhilhealthEmployerAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('PHL ER amount')">{{ errors.first('PHL ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedPhilhealthEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fixed HDMF Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="HDMF amount" v-model="fixedPagibigAmount" />
                  <span class="text-danger text-sm" v-show="errors.has('HDMF amount')">{{ errors.first('HDMF amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedPagibigAmount }}</td>
              </tr>
             <tr>
                <td class="font-semibold">Fixed HDMF ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="HDMF ER amount" v-model="fixedPagibigEmployerAmount" />
                  <span class="text-danger text-sm" v-show="errors.has('HDMF ER amount')">{{ errors.first('HDMF ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedPagibigEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fixed WHTax Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="WHTax amount" v-model="fixedWHTaxAmount" />
                  <span class="text-danger text-sm" v-show="errors.has('WHTax amount')">{{ errors.first('WHTax amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.fixedWHTaxAmount }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>  
              <tr>
                <td class="font-semibold">Percent SSS Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% SSS amount" v-model="percentSSSAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% SSS amount')">{{ errors.first('% SSS amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentSSSAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Percent SSS ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% SSS ER amount" v-model="percentSSSEmployerAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% SSS ER amount')">{{ errors.first('% SSS ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentSSSEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Percent EC Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% EC amount" v-model="percentECAmount" />
                  <span class="text-danger text-sm" v-show="errors.has('% EC amount')">{{ errors.first('% EC amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentECAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Percent PHL Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% PHL amount" v-model="percentPhilhealthAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% PHL amount')">{{ errors.first('% PHL amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentPhilhealthAmount }}</td>
              </tr>
               <tr>
                <td class="font-semibold">Percent PHL ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% PHL ER amount" v-model="percentPhilhealthEmployerAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% PHL ER amount')">{{ errors.first('% PHL ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentPhilhealthEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Percent HDMF Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% HDMF amount" v-model="percentPagibigAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% HDMF amount')">{{ errors.first('% HDMF amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentPagibigAmount }}</td>
              </tr>
             <tr>
                <td class="font-semibold">Percent HDMF ER Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% HDMF ER amount" v-model="percentPagibigEmployerAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% HDMF ER amount')">{{ errors.first('% HDMF ER amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentPagibigEmployerAmount }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Percent WHTax Amount :</td>
                <td v-if="isEdit"> 
                  <vs-input v-validate="'min_value:0'" name="% WHTax amount" v-model="percentWHTaxAmount" /> 
                  <span class="text-danger text-sm" v-show="errors.has('% WHTax amount')">{{ errors.first('% WHTax amount') }}</span>
                </td>
                <td v-else>{{ employeeSalaryInformation.percentWHTaxAmount }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button v-if="!isEdit" @click="EditInfo(employeeSalaryInformation.id)" icon-pack="feather" icon="icon-edit" class="mr-4">Edit</vs-button>
            <vs-button v-else @click.prevent="SaveInfo()"  icon-pack="feather" icon="icon-edit" class="mr-4">Save</vs-button>
            <vs-button v-if="isEdit" @click="Cancel()" type="border" color="danger" icon-pack="feather" icon="icon-trash">Cancel</vs-button>
          </div>

        </div>

      </vx-card>
      

    </div>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    created() {
        this.$vs.loading()
        
        this.$store.dispatch('lookup/getAllSalaryBasedOnLookup').catch((err) => { console.log(err) })
        this.$store.dispatch('lookup/getAllTaxReferenceLookup').catch((err) => { console.log(err) })
        this.$store.dispatch('lookup/getAllPeriodLookup').catch((err) => { console.log(err) })
        this.$store.dispatch('lookup/getAllPaymentModeLookup')
            .then((res => { this.$vs.loading.close() }))
            .catch((err) => { 
                this.$vs.loading.close()
                console.log(err) 
            })
        this.userId = this.$route.params.id

        this.employeeSalaryInformation = this.userId
    //    this.$store.dispatch('hrms/getAllSalaryInformation', this.userId)
    //                     .then((res => { this.$vs.loading.close() }))
    //                     .catch((err) => { this.$vs.loading.close()
    //                     console.log(err) })
            

      
       
    },
   
    computed: {
         employeeSalaryInformation: {
                get() {  return this.$store.state.hrms.employeeSalaryInformation },
                set(value) { this.$store.dispatch('hrms/getAllSalaryInformation', value) }
            
        },
        getAllPaymentModeLookup() {
            return this.$store.state.lookup.getAllPaymentModeLookup.filter(paymentMode => paymentMode.isUsed === true || paymentMode.isUsed === 1)
              // return this.$store.getters['lookup/paymentModeLookupUsed']
        },
        getAllSalaryBasedOnLookup(){
            return this.$store.state.lookup.getAllSalaryBasedOnLookup
        },
        getAllPeriodLookup() {
            const paymentModeId = this.paymentMode && this.paymentMode.paymentModeId
                ? this.paymentMode.paymentModeId
                : this.employeeSalaryInformation.paymentModeId
            return this.$store.getters['lookup/periodLookupByPaymentMode'](paymentModeId)
        },
        getAllTaxReferenceLookup() {
            const paymentMode = this.paymentMode && this.paymentMode.paymentModeCode
                ? this.paymentMode
                : this.paymentModeName(this.employeeSalaryInformation.paymentModeId)
            if (!paymentMode) return []
            const paymentModeCode = String(paymentMode.paymentModeCode || '').trim().toLowerCase()
            const taxReferences = this.$store.state.lookup.getAllTaxReferenceLookup
            const matchingPaymentMode = taxReferences.filter(taxReference =>
                String(taxReference.taxReferenceCode || '').trim().toLowerCase() === paymentModeCode
            )
            const yearly = taxReferences.filter(taxReference =>
                String(taxReference.taxReferenceCode || '').trim().toLowerCase() === 'yl' &&
                String(taxReference.taxReferenceCode || '').trim().toLowerCase() !== paymentModeCode
            )
            return matchingPaymentMode.concat(yearly)
        },
        paymentModeName() {
            return (id) => this.$store.getters['lookup/paymentModeLookup'](id)
        },
        periodName() {
            return (id) => this.$store.getters['lookup/periodLookup'](id)
        },
        salaryBasedOnName() {
            return (id) => this.$store.getters['lookup/salaryBasedOnLookup'](id)
        },
        getTaxReferenceLookup() {
            return this.$store.state.lookup.getTaxReferenceLookup
        },
        taxReferenceName() {
            return (id) => this.$store.getters['lookup/taxReferenceLookup'](id)
        },
    },
    watch: {
        paymentMode(paymentMode, previousPaymentMode) {
            if (!previousPaymentMode || !previousPaymentMode.paymentModeId) return
            if (!paymentMode || paymentMode.paymentModeId === previousPaymentMode.paymentModeId) return

            this.taxReference = this.getAllTaxReferenceLookup[0] || []
            const firstPeriod = this.getAllPeriodLookup[0] || []
            this.sssPeriod = firstPeriod
            this.phlPeriod = firstPeriod
            this.hdmfPeriod = firstPeriod
            this.whtaxPeriod = firstPeriod
        }
    },
    data() {
        return {
            userId: null,
            user_not_found: false,


            isEdit: false,
            id              : 0,
            paymentMode     : [],
            sssNumber       : '',
            philhealthNumber: '',
            pagibigNumber   : '',
            tinNumber       : '',
            taxReference    : [],
            sssPeriod       : [],
            phlPeriod       : [],
            hdmfPeriod      : [],
            whtaxPeriod     : [],
            salaryBasedOn   : [],

            fixedSSSAmount  : '',
            fixedSSSEmployerAmount: '',
            fixedECAmount   : '',
            fixedPhilhealthAmount : '',
            fixedPhilhealthEmployerAmount: '',
            fixedPagibigAmount  : '',
            fixedPagibigEmployerAmount  : '',
            fixedWHTaxAmount  : '',
            
            percentSSSAmount  : '',
            percentSSSEmployerAmount: '',
            percentECAmount   : '',
            percentPhilhealthAmount : '',
            percentPhilhealthEmployerAmount: '',
            percentPagibigAmount  : '',
            percentPagibigEmployerAmount  : '',
            percentWHTaxAmount  : '',





        }
    },
    methods: {
      EditInfo() {
          this.isEdit = true

          this.id = this.employeeSalaryInformation.id
          this.paymentMode = this.paymentModeName(this.employeeSalaryInformation.paymentModeId)
          this.sssNumber = this.employeeSalaryInformation.sssNumber
          this.philhealthNumber = this.employeeSalaryInformation.philhealthNumber,
          this.pagibigNumber = this.employeeSalaryInformation.pagibigNumber
          this.tinNumber = this.employeeSalaryInformation.tinNumber
          this.taxReference = this.taxReferenceName(this.employeeSalaryInformation.taxReferenceId)
          this.sssPeriod = this.periodName(this.employeeSalaryInformation.sssPeriodId)
          this.phlPeriod = this.periodName(this.employeeSalaryInformation.philhealthPeriodId)
          this.hdmfPeriod = this.periodName(this.employeeSalaryInformation.pagibigPeriodId)
          this.whtaxPeriod = this.periodName(this.employeeSalaryInformation.whTaxPeriodId)
          this.salaryBasedOn = this.salaryBasedOnName(this.employeeSalaryInformation.salaryBasedOnId)

          this.fixedSSSAmount = this.employeeSalaryInformation.fixedSSSAmount
          this.fixedSSSEmployerAmount = this.employeeSalaryInformation.fixedSSSEmployerAmount
          this.fixedECAmount  = this.employeeSalaryInformation.fixedECAmount
          this.fixedPhilhealthAmount  = this.employeeSalaryInformation.fixedPhilhealthAmount
          this.fixedPhilhealthEmployerAmount = this.employeeSalaryInformation.fixedPhilhealthEmployerAmount
          this.fixedPagibigAmount = this.employeeSalaryInformation.fixedPagibigAmount
          this.fixedPagibigEmployerAmount = this.employeeSalaryInformation.fixedPagibigEmployerAmount
          this.fixedWHTaxAmount = this.employeeSalaryInformation.fixedWHTaxAmount

          this.percentSSSAmount = this.employeeSalaryInformation.percentSSSAmount
          this.percentSSSEmployerAmount = this.employeeSalaryInformation.percentSSSEmployerAmount
          this.percentECAmount  = this.employeeSalaryInformation.percentECAmount
          this.percentPhilhealthAmount  = this.employeeSalaryInformation.percentPhilhealthAmount
          this.percentPhilhealthEmployerAmount = this.employeeSalaryInformation.percentPhilhealthEmployerAmount
          this.percentPagibigAmount = this.employeeSalaryInformation.percentPagibigAmount
          this.percentPagibigEmployerAmount = this.employeeSalaryInformation.percentPagibigEmployerAmount
          this.percentWHTaxAmount = this.employeeSalaryInformation.percentWHTaxAmount

      },
      SaveInfo() {
          this.$validator.validateAll().then(result => {
          if (result) {
            // if form have no errors
            this.$vs.loading()
            this.isEdit = false

            const data ={
                  id : this.id,
                  paymentModeId : this.paymentMode.paymentModeId,
                  sssNumber : this.sssNumber,
                  philhealthNumber : this.philhealthNumber,
                  pagibigNumber : this.pagibigNumber,
                  tinNumber : this.tinNumber,
                  taxReferenceId : this.taxReference.taxReferenceId,
                  isSSS : this.employeeSalaryInformation.isSSS,
                  isPhilhealth : this.employeeSalaryInformation.isPhilhealth,
                  isPagibig : this.employeeSalaryInformation.isPagibig,
                  isWHTax : this.employeeSalaryInformation.isWHTax,
                  sssPeriodId :this.sssPeriod.periodId,
                  philhealthPeriodId :this.phlPeriod.periodId,
                  pagibigPeriodId :this.hdmfPeriod.periodId,
                  whtaxPeriodId :this.whtaxPeriod.periodId,
                  salaryBasedOnId : this.salaryBasedOn.salaryBasedOnId,

                  fixedSSSAmount : this.fixedSSSAmount,
                  fixedSSSEmployerAmount : this.fixedSSSEmployerAmount,
                  fixedECAmount  : this.fixedECAmount,
                  fixedPhilhealthAmount  : this.fixedPhilhealthAmount,
                  fixedPhilhealthEmployerAmount : this.fixedPhilhealthEmployerAmount,
                  fixedPagibigAmount : this.fixedPagibigAmount,
                  fixedPagibigEmployerAmount : this.fixedPagibigEmployerAmount,
                  fixedWHTaxAmount : this.fixedWHTaxAmount,

                  percentSSSAmount : this.percentSSSAmount,
                  percentSSSEmployerAmount : this.percentSSSEmployerAmount,
                  percentECAmount  : this.percentECAmount,
                  percentPhilhealthAmount  : this.percentPhilhealthAmount,
                  percentPhilhealthEmployerAmount : this.percentPhilhealthEmployerAmount,
                  percentPagibigAmount : this.percentPagibigAmount,
                  percentPagibigEmployerAmount : this.percentPagibigEmployerAmount,
                  percentWHTaxAmount : this.percentWHTaxAmount,
                  userId            : this.userId,
                  currentUserId           : this.$store.state.AppActiveUser.uid

            }
           //console.log(data)
            this.$store.dispatch('hrms/UpdateSalaryInformation', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Salary Information Updated',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
          } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
          }
        })
      },
      Cancel() {
          this.isEdit = false
      }

    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
    }
    
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 200px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
